module.exports = __webpack_public_path__ + "img/_rating_star_grey.224265f4.svg";